import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { Student } from '../../services/model/student';
import { StudentActions } from '../actions/student.actions';


export const studentAdapter: EntityAdapter<Student> = createEntityAdapter<Student>({
  selectId: (student: Student) => student.id,
});

export interface StudentState {
  students: EntityState<Student>;
}

export const initialStudentState: StudentState = {
  students: studentAdapter.getInitialState(),
};

export const studentFeature = createFeature({
  name: 'student',
  reducer: createReducer(
    initialStudentState,
    on(StudentActions.studentsLoaded, (state, { students }) => ({
      ...state,
      students: studentAdapter.setAll(students, state.students),
    })),
    on(StudentActions.reset, () => initialStudentState),
  ),
});